import React from 'react';

import ShadowBox from '../../layoutComponents/shadowBox/ShadowBox';
import PlayerStats from '../playerStats/PlayerStats';

import './PlayerDetailCard.scss';

function PlayerDetailCard({playerInfo}) {
    return (
        <ShadowBox title={playerInfo.name}>
            <div className="playerDetailCard">
                <div>
                    <div className="playerDetailCard__totalPoints">
                        {playerInfo.honor + playerInfo.leetcode_points}
                    </div>
                    {playerInfo.cohort &&
                        <div className="playerDetailCard__cohort">
                            Class: {playerInfo.cohort}
                        </div>
                    }
                </div>
                <div className="playerCard__stats">
                    <PlayerStats playerInfo={playerInfo} title="Points" type="codewars"/> 
                    <PlayerStats playerInfo={playerInfo} title="Commits" /> 
                </div>
            </div>
            
        </ShadowBox>
    );
}

export default PlayerDetailCard;